import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'SplitCamelCase',
})
export class CamelCaseSeparatorPipe implements PipeTransform {
  transform(input: any, args?: any): any {
    if (typeof input !== 'string') {
      return input;
    }

    return input.split(/(?=[A-Z])/).join(' ');
  }
}
